import { Fragment } from "react";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

import img1 from "../../assets/image/course_1.jpg";
import img2 from "../../assets/image/course_2.jpg";
import img3 from "../../assets/image/course_3.jpg";
// import img5 from "../../assets/images/clients/5.png";
import { LazyLoadImage } from "react-lazy-load-image-component";

const BestCompany = () => {
  // const { t } = useTranslation();
  // const { arrivals, loading } = useSelector((state) => state.homeSlicer);

  return (
    <div className="about">
      <div className="container">
        <div className="row">
          <div className="col">
            <div className="section_title_container text-center">
              <h2 className="section_title">Welcome To EDU E-Learning</h2>
              <div className="section_subtitle">
                <p>
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec
                  vel gravida arcu Vestibulum
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="row about_row">
          <div className="col-lg-4 about_col about_col_left">
            <div className="about_item">
              <div className="about_item_image">
                <img src={img1} alt="" />
              </div>
              <div className="about_item_title">
                <a href="#">Our Stories</a>
              </div>
              <div className="about_item_text">
                <p>
                  Lorem ipsum dolor sit , consectet adipisi elit, sed do eiusmod
                  tempor for enim en consectet adipisi elit, sed do consectet
                  adipisi elit, sed doadesg.
                </p>
              </div>
            </div>
          </div>

          <div className="col-lg-4 about_col about_col_middle">
            <div className="about_item">
              <div className="about_item_image">
                <img src={img2} alt="" />
              </div>
              <div className="about_item_title">
                <a href="#">Our Mission</a>
              </div>
              <div className="about_item_text">
                <p>
                  Lorem ipsum dolor sit , consectet adipisi elit, sed do eiusmod
                  tempor for enim en consectet adipisi elit, sed do consectet
                  adipisi elit, sed doadesg.
                </p>
              </div>
            </div>
          </div>

          <div className="col-lg-4 about_col about_col_right">
            <div className="about_item">
              <div className="about_item_image">
                <img src={img3} alt="" />
              </div>
              <div className="about_item_title">
                <a href="#">Our Vision</a>
              </div>
              <div className="about_item_text">
                <p>
                  Lorem ipsum dolor sit , consectet adipisi elit, sed do eiusmod
                  tempor for enim en consectet adipisi elit, sed do consectet
                  adipisi elit, sed doadesg.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BestCompany;
